import React from 'react';

import "./Currency.scss";
import lang from '../../config/lang';



export const Currency = (props) => {
  const { value, decimal, children } = props;

  return (
    <span className="Currency">
      {Number.jet.to(value).toLocaleString(undefined, {
        maximumFractionDigits: decimal
      }) + " " + lang.currency}
      {children}
    </span>
  )
}

